import { Link, RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const finalidades = [
  {
    id: 1,
    left: 'Operar, avaliar e melhorar os serviços e conteúdos, incluindo a anonimização e a análise de dados;',
    right: 'Todos os dados cadastrais',
  },
  {
    id: 2,
    left: 'Realizar estudos e análises, acerca da utilização dos serviços de modo a melhor dimensionar a prestação destes;',
    right: 'Todos os dados cadastrais',
  },
  {
    id: 3,
    left: 'Realizar pesquisas de satisfação e avaliações',
    right: 'Todos os dados cadastrais',
  },
  {
    id: 4,
    left: 'Realizar a movimentação cadastral, inclusões, alterações e atualização das informações com nossos parceiros',
    right: 'Todos os dados cadastrais',
  },
];

const RefundPolicy = () => (
  <RouteWrapper>
    <section>
      <Subtitle>1. Disposições Gerais.</Subtitle>
      <p>
        A CREHANA EDUCATION BRASIL LTDA (<strong>“nós”</strong>,{' '}
        <strong>“Crehana”</strong> ou <strong>“Controladora”</strong>), quer te
        oferecer a melhor experiência possível através de seu serviço e, por
        isso, está empenhada em proteger a sua privacidade, garantindo que seus
        Dados Pessoais sejam tratados de acordo com a Lei Geral de Proteção de
        Dados – Lei nº 13.709/2018 – (<strong>“LGPD”</strong>) e com as melhores
        práticas de mercado. Por isso, somos transparentes em relação às nossas
        práticas e estamos à disposição para conversar sempre que você quiser
      </p>
      <p>
        Esta Política de Privacidade para Clientes (<strong>“Política”</strong>)
        estabelece as regras sobre o uso, armazenamento e Tratamento de Dados
        Pessoais coletados de nossos usuários (<strong>“você”</strong>,{' '}
        <strong>“seu”</strong> / <strong>“sua”</strong> e{' '}
        <strong>“Usuário”</strong>), ao acessarem e/ou se registrarem nos sites
        da Crehana e/ou plataformas virtuais relacionadas (
        <strong>&quot;Plataforma&quot;</strong>), bem como os motivos pelos
        quais o fazemos.
      </p>
      <p>
        A Crehana é empresa brasileira pertencente ao “Grupo CREHANA” composto
        pelas seguintes empresas:
        <ul>
          <li>
            Crehana Education México, S. de R.L. de C.V., com sede na Paseo de
            la Reforma nº 26, piso 12, Colonia Juárez, Alcaldía Cuauhtémoc, C.P.
            06600, Cidade do México.
          </li>
          <li>
            Crehana Educação Peru S.A.C., com sede na Avenida Larco nº 1232,
            distrito de Miraflores, cidade e província de Lima.
          </li>
          <li>
            Crehana Educação Colômbia S.A.S., com sede na Carrera 18a # 103-11,
            cidade de Bogotá.
          </li>
          <li>
            Crehana Educação Chile Capacitaciones SpA, com sede na Avenida
            Providencia N° 1650, Oficina 611, comuna de Providencia, Ciudad de
            Santiago, Región Metropolitana.
          </li>
          <li>
            Crehana Education Inc., com sede na 2035 Sunset Lake Road, Suite
            B-2, cidade de Newark, condado de New Castle, 19702, Delaware, EUA.
          </li>
          <li>
            Crehana Education Brasil Ltda, com sede na Cidade de São Paulo,
            Estado de São Paulo, na Avenida Paulista, nº 1.471, conjunto 511,
            Bela Vista, CEP 01311-927, Brasil.
          </li>
          <li>Acsendo S.A.S, Colombia, Rua 96 #12-31, Bogotá, Colombia.</li>
        </ul>
      </p>
      <p>
        Crehana atua como Controladora no escopo previsto nesta Política sendo,
        portanto, responsável por tomar as decisões relacionadas ao Tratamento
        de Dados Pessoais sob sua responsabilidade, conforme detalhado neste
        documento. Assim, Crehana tem por diretriz o cumprimento das obrigações
        determinadas pela LGPD e eventuais regulamentos da ANPD, quando
        aplicáveis, e seguimos também os seguintes princípios ao tratarmos seus
        dados:
      </p>
      <p>
        (i) Usamos os Dados Pessoais para propósitos legítimos, específicos,
        explícitos e informados a você por meio desta Política;
      </p>
      <p>
        (ii) Solicitamos atualizações de seus Dados Pessoais sempre que
        necessário para a finalidade do respectivo Tratamento;
      </p>
      <p>
        (iii) Tratamos os Dados Pessoais com o cuidado necessário para prevenir
        eventuais danos em virtude dessas atividades de Tratamento; e
      </p>
      <p>
        (iv) Utilizamos os Dados Pessoais somente para fins que não sejam
        discriminatórios, ilícitos ou abusivos.
      </p>
    </section>
    <section>
      <Subtitle>2. Definições aplicáveis</Subtitle>
      <p>
        Veja abaixo algumas definições importantes para entender melhor a
        proteção que aplicamos aos seus Dados Pessoais, os limites do nosso uso
        e seus direitos:
      </p>
      <p>
        (i) <strong>“Dado Pessoal”</strong> significa toda informação
        relacionada a pessoa natural identificada ou identificável, nos termos
        da LGPD, originados ou coletados pelo Controlador; ou aqueles coletados,
        gerados, ou de qualquer maneira tratados pelo Controlador;
      </p>
      <p>
        (ii) <strong>“Dado Pessoal Sensível”</strong> significa Dado Pessoal
        sobre origem racial ou étnica, convicção religiosa, opinião política,
        filiação a sindicato ou a organização de caráter religioso, filosófico
        ou político, Dado Pessoal referente à saúde ou à vida sexual, Dado
        genético ou biométrico, quando vinculado a uma pessoa natural, nos
        termos da LGPD; originados ou coletados pelo Controlador; ou aqueles
        coletados, gerados, ou de qualquer maneira Tratados pelo Controlador;
      </p>
      <p>
        (iii) <strong>“Anonimização de Dados”</strong> significa o processo pelo
        meio do qual um Dado Pessoal relativo a um Titular deixa de ser
        identificado, considerando a utilização de meios técnicos razoáveis e
        disponíveis na ocasião de seu Tratamento;
      </p>
      <p>
        (iv) <strong>“Titular”</strong> significa pessoa natural identificada ou
        identificável a quem se referem os Dados Pessoais que são objeto de
        Tratamento;
      </p>
      <p>
        (v) <strong>“Transferência Internacional”</strong> significa
        transferência de Dados Pessoais do Brasil para país estrangeiro ou
        organismo internacional do qual o país seja membro;
      </p>
      <p>
        (vi) <strong>“Tratamento”</strong> significa toda operação realizada com
        Dados Pessoais, como as que se referem a coleta, produção, recepção,
        classificação, utilização, acesso, reprodução, transmissão,
        distribuição, processamento, arquivamento, armazenamento, eliminação,
        avaliação ou controle da informação, modificação, comunicação,
        transferência, difusão ou extração, nos termos da LGPD;
      </p>
      <p>
        (vii) <strong>“Controladora”</strong> significa a pessoa natural ou
        jurídica a quem competem as decisões referentes ao Tratamento de Dados
        Pessoais, neste caso, Crehana;
      </p>
      <p>
        (viii) <strong>“Operador”</strong> significa pessoa natural ou jurídica
        que realiza o Tratamento de Dados Pessoais em nome do Controlador;
      </p>
      <p>
        (ix) <strong>“Encarregado”</strong> (ou “Data Protection Officer” ou
        “DPO”) é pessoa, física ou jurídica, designada pela empresa, para
        atender funções consultivas sobre proteção de Dados e de supervisão da
        conformidade com a LGPD e com políticas internas. Cabe ao Encarregado:
        (a) verificar a aplicação efetiva de princípios de privacidade desde a
        concepção e de privacidade por padrão, participando de processos de
        projeto de Tratamento, da Avaliação de Impacto de Proteção de Dados
        (“DPIA”) e conduzindo análises profundas e adequadas para verificar a
        conformidade com a LGPD; bem como (b) aceitar reclamações e comunicações
        dos Titulares, prestando a eles esclarecimentos e adotando providências;
        (c) receber comunicações da ANPD e adotar as devidas providências; e
        ainda (d) executar as demais atribuições determinadas pelo Controlador;
      </p>
      <p>
        (x) <strong>“Consentimento”</strong> significa a manifestação livre,
        informada e inequívoca pela qual o Titular concorda com o Tratamento de
        seus Dados Pessoais;
      </p>
      <p>
        (xi) <strong>“Autoridade Nacional de Proteção de Dados”</strong> (ou
        “ANPD”) significa órgão da administração pública responsável por zelar,
        implementar e fiscalizar o cumprimento da LGPD em todo o território
        nacional brasileiro;
      </p>
      <p>
        (xii) <strong>“Lei Geral de Proteção de Dados”</strong> (ou “LGPD”)
        significa Lei nº 13.709/2018, responsável por dispor sobre Tratamento de
        Dados Pessoais, em meios físicos e digitais, a qual é aplicável em toda
        operação de Tratamento realizada no território nacional brasileiro; toda
        operação que tenha por objetivo fornecer bens ou serviços no território
        nacional brasileiro; toda operação que envolva Dados Pessoais de
        Titulares localizados no território nacional brasileiro; ou toda
        operação cujos Dados Pessoais tenham sido coletados no território
        nacional brasileiro; e
      </p>
      <p>
        (xiii) <strong>“Melhores Práticas do Mercado”</strong> significam
        normas, práticas, métodos e procedimentos conformes com as Normas
        Aplicáveis e o grau de capacidade e zelo, diligência, prudência e
        precaução que seria razoável e comumente esperado de operador
        qualificado e experiente participante de atividade semelhante em
        circunstâncias semelhantes.
      </p>
    </section>
    <section>
      <Subtitle>Dados Pessoais Coletados</Subtitle>
      <p>
        Podemos coletar, armazenar ou, de forma geral, Tratar Dados Pessoais
        associados às categorias de dados abaixo, sem limitação:
      </p>
      <p>
        (i) <strong>“Dados Cadastrais”</strong>: nome completo, endereços
        residenciais, números de telefone, data de nascimento, endereços de
        e-mail, entre outros;
      </p>
      <p>
        (ii) <strong>“Dados de Dependentes e Familiares”</strong>: nome, data de
        nascimento, grau de parentesco, entre outros;
      </p>
      <p>
        (iii) <strong>“Dados Bancários”</strong>: informações de pagamento;
      </p>
      <p>
        A CREHANA e parceiros poderão coletar informações sobre o Titular
        diretamente ou por meios automatizados, como cookies, quando o Titular
        interage com anúncios ou aplicativos móveis, ou quando visita sites,
        perfis ou outros recursos digitais da CREHANA e parceiros, conforme
        indicado no item 4, abaixo.
      </p>
    </section>
    <section>
      <Subtitle>Política de Cookies</Subtitle>
      <p>
        Visando proporcionar uma melhor experiência aos visitantes da Plataforma
        e melhorar nossos Serviços, utilizamos Cookies, que nada mais são do que
        arquivos de texto armazenados no seu navegador, celular ou outro
        dispositivo, que nos permitem oferecer-lhes uma experiência de acesso
        personalizada, publicidade, identificação de localidade e idioma de
        acesso, visualizar seus hábitos de acesso na Plataforma, e nos ajudam a
        manter a segurança e autenticação de acessos na Plataforma, para que
        possamos melhorar a estrutura de nossa Plataforma, bem como melhorar o
        desempenho e personalizar conteúdo de acordo com seu uso.
      </p>
      <p>
        Lembramos que é possível gerenciar, e até mesmo desabilitar, os cookies
        nas configurações do seu navegador. No entanto, lembramos que alguns
        deles são necessários para o correto funcionamento da Plataforma, de
        modo que ao desabilitar todos os cookies o acesso integral a Plataforma,
        seus conteúdos e suas funcionalidades poderão ser comprometidos.
      </p>
      <p>
        Também trabalhamos com ferramentas analíticas como o Google Analytics, o
        Facebook Pixel, que usam cookies e tecnologias similares para nos ajudar
        a entender e analisar como os usuários utilizam nossa Plataforma e
        serviços. Esses provedores de serviços poderão coletar estes dados de
        forma independente para recebê-los por compartilhamento conosco.
      </p>
    </section>
    <section>
      <Subtitle>Finalidade de Tratamento de Dados Pessoais Coletados</Subtitle>
      <p>
        Abaixo, listamos exemplos de situações nas quais coletamos seus Dados
        Pessoais, a finalidade e os Dados Pessoais envolvidos. Esta tabela
        poderá ser atualizada conforme a necessidade de refletir a prática de
        Crehana. Por isso, recomendamos que você acesse este documento e analise
        a tabela periodicamente.
      </p>

      <div className="my-24" style={{ border: '1px solid #181B32' }}>
        <div className="flex items-center">
          <div className="w-1/2" style={{ borderRight: '1px solid #181B32' }}>
            <p className="text-center">
              <strong>FINALIDADE</strong>
            </p>
          </div>
          <div className="w-1/2">
            <p className="text-center">
              <strong>CATEGORIAS DE DADOS PESSOAIS</strong>
            </p>
          </div>
        </div>
        {finalidades.map(row => (
          <div
            key={row.id}
            className="flex"
            style={{ borderTop: '1px solid #181b32' }}
          >
            <div
              className="w-1/2 p-4"
              style={{ borderRight: '1px solid #181B32' }}
            >
              <p>{row.left}</p>
            </div>
            <div className="w-1/2 p-4">
              <p>{row.right}</p>
            </div>
          </div>
        ))}
      </div>
      <p>
        Nos termos da LGPD, a Crehana somente tratará seus Dados Pessoais
        fundamentando essa atividade em uma das bases legais disponíveis para o
        tratamento, obtendo seu consentimento sempre que necessário e exigido
        por lei. De toda forma, destacamos que a Crehana poderá tratar seus
        dados também para cumprir com leis e regulamentos aplicáveis aos seus
        negócios, de acordo com seu legítimo interesse ou mesmo para defender
        seus direitos em eventuais procedimentos judiciais, administrativos ou
        arbitrais.
      </p>
    </section>
    <section>
      <Subtitle>6. Compartilhamento de Dados Pessoais</Subtitle>
      <p>
        Crehana poderá operar em parceria com uma série de outras organizações
        visando o fornecimento dos serviços, monitoramento, coleta de Dados
        Pessoais, entre outros, sempre em linha com as finalidades indicadas
        nesta Política. Assim, em certos casos, é necessário compartilhar Dados
        Pessoais que são confiados com alguns parceiros e fornecedores, bem como
        com autoridades públicas para cumprir exigências legais, conforme
        indicado abaixo.
      </p>
      <ul>
        <li>
          <u>Empresas do Grupo CREHANA</u>: Os Dados dos usuários podem ser
          compartilhados entre as áreas de negócios e demais empresas do Grupo
          CREHANA para desenvolver novos conteúdos e serviços, melhorar a
          experiência do usuário, realizar análises de dados e atender a outros
          interesses legítimos;
        </li>
        <li>
          <u>Fornecedores e parceiros</u>: Para viabilizar a operação e oferecer
          os serviços, o Grupo CREHANA conta com o apoio de fornecedores e
          parceiros terceiros. E, quando necessário à prestação do serviço, o
          Grupo CREHANA pode compartilhar os Dados Pessoais coletados com tais
          parceiros como, por exemplo, aqueles que prestam serviços de prevenção
          à fraude, e atendimento ao usuário, entre outros;
        </li>
        <li>
          <u>Analytics</u>: Os Dados Pessoais armazenados pelo Grupo CREHANA
          podem vir a ser utilizados para fins de analytics, visando compreender
          a interação dos usuários com a Plataforma, para melhoramento da
          experiência deste, dos serviços e dos conteúdos. Estes Dados Pessoais
          são pseudonimizados e não identificam ou tornam identificáveis os
          indivíduos a eles relacionados.
        </li>
        <li>
          <u>Autoridades policiais e governamentais</u>: Mediante obrigação
          legal ou regulatória que determine o fornecimento de Dados Pessoais a
          alguma autoridade, o Grupo CREHANA procederá conforme a lei, bem como
          nos casos de um juiz ou autoridade policial com competência legal ou
          regulatória exigir que o Grupo CREHANA compartilhe certos Dados
          Pessoais com fins legítimos e legais, observado o disposto em lei, o
          Grupo CREHANA será obrigado a fazê-lo.
        </li>
      </ul>
      <p>
        Sempre que o compartilhamento for necessário, o Grupo CREHANA avaliará
        individualmente os parceiros e fornecedores, bem como buscará firmar
        obrigações contratuais de segurança da informação e proteção de Dados
        Pessoais com o objetivo de mitigar riscos à proteção de dados.
      </p>
      <p>
        Seus Dados Pessoais não serão transferidos, vendidos, alugados ou
        divulgados de qualquer maneira que não esteja escrita nesta Política de
        Privacidade.
      </p>
    </section>
    <section>
      <Subtitle>7. Transferência internacional de Dados Pessoais</Subtitle>
      <p>
        Em determinadas situações, o compartilhamento de Dados Pessoais indicado
        anteriormente pode implicar em transferência internacional de dados.
        Nestes casos, asseguramos que todas as medidas necessárias são tomadas
        para garantir que o Tratamento de Dados Pessoais pelo receptor ocorrerá
        de acordo com as disposições da LGPD. Por exemplo, embora seja uma
        empresa sediada no Brasil, com seus serviços destinados a empresas
        localizadas no Brasil, a Crehana faz parte de um grupo empresarial
        multinacional , de modo que os Dados Pessoais que coletamos podem ser
        transferidos para outras empresas do grupo, localizadas fora do Brasil.
        Essas transferências podem ocorrer por razões de gestão interna,
        decorrente de nacionalidade dos servidores e hospedagem e nuvem da
        Plataforma e seus conteúdos, ou ainda para parceiros e fornecedores
        localizados no exterior.
      </p>
    </section>
    <section>
      <Subtitle>8. Retenção de Dados Pessoais</Subtitle>
      <p>
        Os Dados Pessoais são retidos exclusivamente pelo tempo que for
        necessário para cumprir com as finalidades para as quais foram
        coletados, salvo se houver outra razão para sua manutenção como, por
        exemplo, cumprimento de obrigações legais, regulatórias ou contratuais,
        exercício regular de direitos em processo administrativo, judicial ou
        arbitral, entre outras permitidas pela LGPD.
      </p>
      <p>
        Em algumas circunstâncias, podemos anonimizar os Dados Pessoais para que
        eles não possam mais ser associados a Você, por meio da utilização de
        meios técnicos razoáveis e disponíveis na ocasião de seu Tratamento.
        Nesses casos as informações não serão mais consideradas Dados Pessoais
        nos termos da LGPD, e poderão ser utilizadas por Crehana sem restrições.
      </p>
    </section>
    <section>
      <Subtitle>9. Segurança dos Dados Pessoais</Subtitle>
      <p>
        A Crehana adota medidas de segurança adequadas para proteger seus Dados
        Pessoais contra acessos não autorizados e situações acidentais ou
        ilícitas de destruição, perda, alteração, comunicação ou difusão de suas
        informações (“Incidentes de Segurança”). Limitamos o acesso e Tratamento
        de Dados Pessoais apenas ao estritamente necessário para atingirmos as
        finalidades indicadas neste documento.
      </p>
      <p>
        Os Dados Pessoais coletados são armazenados em ambiente seguro,
        observado o estado da técnica disponível, e somente poderão ser
        acessados por pessoas qualificadas e autorizadas por Crehana, de acordo
        com a necessidade de acesso.
      </p>
      <p>
        Dispomos ainda de procedimentos para lidar com violações de segurança
        suspeitas ou de fato verificadas, que podem acarretar Incidentes de
        Segurança. Nestas situações notificaremos a ANPD e os Titulares,
        conforme disposições da LGPD. Caso identifique ou tome conhecimento de
        qualquer fator que comprometa a segurança dos Dados Pessoais tratados
        nas atividades da Plataforma e serviços da CREHANA, por favor entrar em
        contato através do e-mail: [tatiane.brito@crehana.com]
        [legal@crehana.com].
      </p>
    </section>
    <section>
      <Subtitle>10. Direitos do Titular de Dados Pessoais</Subtitle>
      <p>
        Crehana confere, aos Titulares de Dados Pessoais coletados em função
        desta Política, os direitos previstos na LGPD. Em determinadas
        circunstâncias, você, como Titular dos Dados Pessoais, tem os seguintes
        direitos:
      </p>
      <p>
        1. Confirmar se estamos tratando quaisquer Dados Pessoais relacionados a
        você;
      </p>
      <p>
        2. Obter informações, de forma clara, adequada e ostensiva, sobre o
        Tratamento de seus Dados Pessoais, como a finalidade do Tratamento, o
        período durante o qual serão armazenados e com quem compartilhamos, e
        quais Dados Pessoais temos a seu respeito;
      </p>
      <p>
        3. Acessar os Dados Pessoais que temos a seu respeito, obtendo inclusive
        uma cópia, se o Tratamento for pautado no seu Consentimento;
      </p>
      <p>
        4. Corrigir qualquer informação incorreta, incompleta ou desatualizada
        sobre você;
      </p>
      <p>
        5. Solicitar a eliminação de seus Dados Pessoais que estejam sendo
        tratados com base no seu Consentimento – no entanto, não podemos
        eliminar Dados Pessoais que são necessários para cumprirmos obrigações
        legais –;
      </p>
      <p>
        6. Solicitar, a qualquer momento, a anonimização ou o bloqueio de seus
        Dados Pessoais que não sejam necessários ou tratados em conformidade com
        a lei;
      </p>
      <p>
        7. Ser informado sobre as entidades públicas e privadas com quem
        compartilhamos seus Dados Pessoais, caso aplicável;
      </p>
      <p>
        8. Ser informado sobre a possibilidade de não fornecimento de
        Consentimento e sobre as consequências desta negativa;
      </p>
      <p>
        9. Revogar seu Consentimento, a qualquer momento, quanto ao Tratamento
        de seus Dados Pessoais;
      </p>
      <p>
        10. Se opor ao Tratamento realizada com base em outra base legal que não
        o legítimo interesse;
      </p>
      <p>
        11. Solicitar a revisão de decisões tomadas unicamente com base em
        Tratamento automatizado de seus Dados Pessoais que afetem seus
        interesses, incluídas as decisões destinadas a definir o seu perfil
        pessoal, profissional, de consumo e de crédito ou os aspectos de sua
        personalidade; e
      </p>
      <p>
        12. Ser informado sobre critérios e dos procedimentos utilizados para a
        decisão automatizada.
      </p>
      <p>
        Você poderá exercer qualquer desses direitos de maneira gratuita pelo
        seguinte canal de atendimento, destinado a esse assunto: [Canal: e-mail
        tatiane.brito@crehana.com], [legal@crehana.com].
      </p>
      <p>
        No entanto, o exercício destes direitos pode eventualmente ser limitado
        por algumas exceções, como por exemplo, a salvaguarda de interesse
        público ou do nosso interesse (manutenção do sigilo profissional,
        comercial e industrial e obrigações legais, exercício regular de
        direitos, dentre outros), nos limites permitidos pela LGPD. Em certos
        casos e com base na lei, se sua solicitação não puder ser atendida, lhe
        informaremos sempre mediante a justificativa para tanto.
      </p>
    </section>
    <section>
      <Subtitle>11. Atualização da Política</Subtitle>
      <p>
        Esta Política poderá ser atualizada periodicamente para refletir as
        alterações introduzidas nas práticas em matéria de Dados Pessoais. A
        CREHANA notificará o Titular mediante informe individual enviado pelos
        canais de comunicação habituais, bem como publicará informe em destaque
        na Plataforma, para dar ao Titular conhecimento sobre alterações
        significativas e/ou materiais da Política, antes de que se tornem
        vigentes, com indicação do início.
      </p>
    </section>
    <section>
      <Subtitle>12. Contato CREHANA</Subtitle>
      <p>
        Em caso de dúvidas, comentários ou reclamações sobre esta Política e as
        práticas de privacidade do Grupo CREHANA, o Titular ou qualquer
        interessado poderá contar o encarregado de Proteção de Dados do Grupo
        CREHANA no e-mail: [tatiane.brito@crehana.com, legal@crehana.com , ou
        faça contato por meio dos canais de atendimento disponíveis em
        <Link href="https://www.crehana.com/br/" />.
      </p>
    </section>
  </RouteWrapper>
);

export default RefundPolicy;
